export { default } from './Tabs.jsx';
